import styled from 'styled-components'

export const MainContent = styled.div`
  background-color: var(--color-page);
  height: 100%;
  overflow: auto;
  padding: var(--spacing-content-gutter);
  font-family: var(--text-font);
`
